<template>
  <div>
    <div class="row my-4 align-items-center">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4">
            <vue-select
              name="periodo"
              v-model="periodo"
              class="select-periodo"
              :clearable="false"
              :options="optionsPeriodo"
              label="label"
              placeholder="Período"
              @input="onChangePeriodo"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-8">
            <vue-select
              id="select-escore"
              name="escore"
              v-model="escore"
              class="select-escore"
              :clearable="false"
              :options="optionsEscore"
              label="label"
              placeholder="Escore"
              @input="onChangeEscore"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="escore-filtros-2">
          <b-form-radio-group
            id="radio-group-2"
            v-model="selectedFilter"
            :options="optionsCheckbox"
            name="filter-options"
            @change="onChangeRadio"
          ></b-form-radio-group>

          <div
            v-if="exibirFiltroPrevistoRealizado"
            class="escore-filtro-previsto-realizado"
          >
            <ResultadoToggle v-model="tipoResultado" :disabledMensal="true" />

            <FiltroPrevistoRealizado v-model="filtroResultadoQuadrimestral" />
          </div>

          <download-files
            :callback-pdf="generatePdf"
            :data="mapCadastrosForXls(dadosDaTabela)"
            :fields="fieldsForXls"
            name="resultado-municipal-escore"
            class="float-right"
          />
        </div>
      </div>
    </div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar por CNES, UBS, Equipe, Classificação ou INE"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="dadosDaTabela"
            :item-class="getRowColor"
            :search="search"
            :single-expand="true"
            :expanded.sync="expanded"
            item-key="id"
            class="elevation-1"
            show-expand
          >
            <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

            <template v-slot:item.no_indicador="{ item }">
              {{ item.indicador }}
            </template>
            <template v-slot:item.escore="{ item }">
              {{ item.escore }}
            </template>

            <template v-slot:expanded-item="{ item }">
              <td :colspan="headers.length">
                <table class="table table-interna" style="width: 100%">
                  <thead>
                    <tr>
                      <th v-for="(col, index) in expandedColumns" :key="index">
                        {{ col }}
                        <span
                          v-b-tooltip.hover.right
                          :title="expandedColumnTooltips[col]"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-for="(col, index) in expandedColumns" :key="index">
                        {{ getExpandedValue(item, col) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>

            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFieldsEscore, dataFieldsEscorePrevistoRealizado } from './utils.js'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import FiltroPrevistoRealizado from './components/FiltroPrevistoRealizado.vue'
import ResultadoToggle from './components/ResultadoToggle.vue'

export default {
  name: 'TabelaEscore',
  components: {
    ShowHideField,
    DownloadFiles,
    FiltroPrevistoRealizado,
    ResultadoToggle,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      expandedColumnTooltips: {
        CIs: 'Total de Cadastro Individual (CI).',
        'CIs + CDTs':
          'Total de Cadastros Individuais (CI) + Total de Cadastros Domiciliares e Territoriais (CDT).',
        Cadastros: 'Total de cadastros no e-SUS PEC.',
        Parâmetro:
          'Quantidade mínima de cadastros estabelecida no cofinanciamento federal da APS.',
        A: 'População acompanhada sem critério × 1,0',
        B: 'População acompanhada idosa ou criança × 1,2',
        C: 'População acompanhada beneficiária do PBF ou BPC × 1,3',
        D: 'População acompanhada idosa ou criança e beneficiária do PBF ou BPC × 2,5',
        'Escore cadastros':
          'Nota do cadastro definida na portaria na nota metodológica.',
        'Escore Acompanhamento':
          'Nota do acompanhamento definida na nota metodológica do vínculo e acompanhamento.',
        Máximo:
          'Estimativa da quantidade máxima de pessoas para serem cadastradas na equipe no vínculo e acompanhamento.',
      },
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Microárea',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: 'Escore',
          align: 'start',
          filterable: false,
          value: 'escore',
        },
        {
          text: 'Classificação',
          align: 'start',
          filterable: true,
          value: 'classificacao',
        },
        { text: '', value: 'data-table-expand' },
      ],
      periodo: null,
      optionsPeriodo: [],
      escore: {
        value: 'vinculo-acompanhamento-por-parametro-de-cadastro',
        label: 'Vínculo e acompanhamento por parâmetro de cadastro',
        indicador: '56',
      },
      optionsEscore: [
        {
          label: 'Vínculo por cadastro no e-SUS',
          value: 'por-cadastro-esus',
          indicador: '35',
        },
        {
          label: 'Vínculo por parâmetro de cadastro',
          value: 'por-parametro',
          indicador: '54',
        },
        {
          value: 'acompanhamento-por-cadastro-esus',
          label: 'Acompanhamento por cadastro e-SUS',
          indicador: '36',
        },
        {
          value: 'acompanhamento-por-parametro-de-cadastro',
          label: 'Acompanhamento por parâmetro de cadastro',
          indicador: '55',
        },
        {
          value: 'vinculo-acompanhamento-por-cadastro-esus',
          label: 'Vínculo e acompanhamento por cadastro e-SUS',
          indicador: '37',
        },
        {
          value: 'vinculo-acompanhamento-por-parametro-de-cadastro',
          label: 'Vínculo e acompanhamento por parâmetro de cadastro',
          indicador: '56',
        },
      ],
      dataFieldsEscore: {
        ...dataFieldsEscore,
      },
      selectedCheckbox: ['equipes'],
      selectedFilter: 'equipes',
      optionsCheckbox: [
        { text: 'Município', value: 'municipio' },
        { text: 'Equipes', value: 'equipes' },
        { text: 'Microáreas', value: 'microarea' },
      ],
      dadosDaTabela: [],
      tipoResultado: 'quadrimestral',
      filtroResultadoQuadrimestral: 'previsto',
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },

    filtroResultadoQuadrimestral() {
      this.filterData(this.periodo, this.escore, [this.selectedFilter])
    },
  },
  computed: {
    fieldsForXls() {
      const mainHeaders = this.isRealizadoSelecionado
        ? { ...dataFieldsEscorePrevistoRealizado }
        : { ...dataFieldsEscore }

      const extraHeaders = this.expandedColumns.reduce((acc, col) => {
        acc[col] = {
          field: col,
          callback: (value) => {
            return value != null && value !== ''
              ? `​  ​​${value.toString()}`
              : ''
          },
        }

        return acc
      }, {})

      return { ...mainHeaders, ...extraHeaders }
    },

    expandedColumns() {
      if (
        this.escore.value === 'por-cadastro-esus' ||
        this.escore.value === 'por-parametro'
      ) {
        return ['CIs', 'CIs + CDTs', 'Cadastros', 'Parâmetro', 'Máximo']
      } else if (
        this.escore.value === 'acompanhamento-por-cadastro-esus' ||
        this.escore.value === 'acompanhamento-por-parametro-de-cadastro'
      ) {
        return ['A', 'B', 'C', 'D', 'Cadastros', 'Parâmetro', 'Máximo']
      } else if (
        this.escore.value === 'vinculo-acompanhamento-por-cadastro-esus' ||
        this.escore.value === 'vinculo-acompanhamento-por-parametro-de-cadastro'
      ) {
        return ['Escore cadastros', 'Escore Acompanhamento']
      }
      return []
    },

    exibirFiltroPrevistoRealizado() {
      if (!this.periodo || !this.escore || !this.escore.indicador) {
        return false
      }

      const mes = Number(this.periodo.value.split('/')[0])
      const indicador = Number(this.escore.indicador)

      return [4, 8, 12].includes(mes) && [56].includes(indicador)
    },

    isRealizadoSelecionado() {
      return (
        this.exibirFiltroPrevistoRealizado &&
        this.filtroResultadoQuadrimestral === 'realizado'
      )
    },
  },
  methods: {
    /**
     * Retorna os dados importados do SIAPS.
     *
     * @param {Object} item Registro da série histórica.
     * @returns {Object|null}
     */
    getDadosMs(item) {
      if (!item.dados_ms) {
        return null
      }

      return this.parseObjectJson(item.dados_ms)
    },

    /**
     * Retorna um indicador realizado dentro de dados_ms.
     *
     * @param {Object} item Registro da série histórica.
     * @param {Number|String} indicador Código do indicador.
     * @returns {Object|null}
     */
    getIndicadorRealizado(item, indicador) {
      const dadosMs = this.getDadosMs(item)

      if (!dadosMs || !Array.isArray(dadosMs.all_indicadores)) {
        return null
      }

      return (
        dadosMs.all_indicadores.find(
          (el) => Number(el.indicador) === Number(indicador)
        ) || null
      )
    },

    /**
     * Retorna o escore realizado conforme o indicador selecionado.
     *
     * @param {Object} item Registro da série histórica.
     * @returns {*}
     */
    getEscoreRealizado(item) {
      const indicador = Number(this.escore.indicador)
      const dadosMs = this.getDadosMs(item)

      if (!dadosMs) {
        return '-'
      }

      if (indicador === 56) {
        return dadosMs.resultado ?? '-'
      }

      const indicadorRealizado = this.getIndicadorRealizado(item, indicador)

      return indicadorRealizado?.resultado ?? '-'
    },

    /**
     * Retorna a classificação realizada conforme o indicador selecionado.
     *
     * @param {Object} item Registro da série histórica.
     * @returns {*}
     */
    getClassificacaoRealizada(item) {
      const indicador = Number(this.escore.indicador)
      const dadosMs = this.getDadosMs(item)

      if (!dadosMs) {
        return '-'
      }

      if (indicador === 56) {
        return dadosMs.classificacao ?? '-'
      }

      const indicadorRealizado = this.getIndicadorRealizado(item, indicador)

      return indicadorRealizado?.classificacao ?? '-'
    },

    /**
     * Retorna o valor no formato previsto ou previsto / realizado.
     *
     * @param {*} previsto Valor previsto.
     * @param {*} realizado Valor realizado.
     * @returns {*}
     */
    getValorPrevistoRealizado(previsto, realizado) {
      if (!this.isRealizadoSelecionado) {
        return previsto
      }

      return `${previsto ?? '-'} / ${realizado ?? '-'}`
    },

    /**
     * Aplica o filtro de nível (Município, Equipes ou Microáreas)
     * e atualiza os dados exibidos na tabela.
     *
     * @param {String} value Nível selecionado.
     * @returns {void}
     */
    onChangeRadio(value) {
      this.filterData(this.periodo, this.escore, [value])
    },

    /**
     * Gera a estrutura utilizada para exportação da tabela em XLS.
     *
     * @returns {void}
     */
    generateXls() {
      const data_xls = this.mapCadastrosForXls(this.dadosDaTabela)

      // Cabeçalho principal
      const mainHeaders = [
        { label: 'CNES', field: 'nu_cnes' },
        { label: 'UBS', field: 'no_unidade_saude' },
        { label: 'INE', field: 'nu_ine' },
        { label: 'Microárea', field: 'micro_area' },
        { label: 'Escore', field: 'escore' },
        { label: 'Classificação', field: 'classificacao' },
      ]

      // Cabeçalhos adicionais -expandidos
      const expandedHeaders = this.expandedColumns.map((col) => ({
        label: col,
        field: col,
      }))

      const headers_xls = [...mainHeaders, ...expandedHeaders]

      this.$refs.downloadExcel.downloadExcel({
        data: data_xls,
        fields: headers_xls,
        filename: 'desempenho-por-equipe-escore.xls',
        worksheet: 'Desempenho por Equipe',
      })
    },

    /**
     * Converte os registros da tabela para o formato
     * utilizado na exportação em XLS.
     *
     * @param {Array} cadastros Lista de registros.
     * @returns {Array}
     */
    mapCadastrosForXls(cadastros) {
      return cadastros.map((item, index) => {
        let row = {
          nu_cnes: item.nu_cnes,
          no_unidade_saude: item.no_unidade_saude,
          nu_ine: '\u200B' + item.nu_ine,
          micro_area: item.micro_area,
        }

        if (this.isRealizadoSelecionado) {
          row.escore_previsto = item.escore_previsto
          row.escore_realizado = item.escore_realizado
          row.classificacao_prevista = item.classificacao_prevista
          row.classificacao_realizada = item.classificacao_realizada
        } else {
          row.escore = item.escore
          row.classificacao = item.classificacao
        }

        this.expandedColumns.forEach((col) => {
          row[col] = this.getExpandedValue(item, col)
        })
        return row
      })
    },

    /**
     * Converte os registros da tabela para o formato
     * utilizado na exportação em PDF.
     *
     * @param {Array} cadastros Lista de registros.
     * @returns {Array}
     */
    mapCadastrosForPdf(cadastros) {
      return cadastros.map((item, index) => {
        let row = {
          nu_cnes: item.nu_cnes,
          no_unidade_saude: item.no_unidade_saude,
          nu_ine: '\u200B' + item.nu_ine,
          micro_area: item.micro_area,
        }

        if (this.isRealizadoSelecionado) {
          row.escore_previsto = item.escore_previsto
          row.escore_realizado = item.escore_realizado
          row.classificacao_prevista = item.classificacao_prevista
          row.classificacao_realizada = item.classificacao_realizada
        } else {
          row.escore = item.escore
          row.classificacao = item.classificacao
        }

        this.expandedColumns.forEach((col) => {
          row[col] = this.getExpandedValue(item, col)
        })
        return row
      })
    },

    /**
     * Retorna o valor exibido na tabela expandida conforme
     * o indicador e a coluna selecionados.
     *
     * Também aplica a regra de exibição do resultado
     * previsto ou previsto / realizado quando aplicável.
     *
     * @param {Object} item Registro da tabela.
     * @param {String} column Nome da coluna expandida.
     * @returns {*}
     */
    getExpandedValue(item, column) {
      const dados =
        typeof item.dados === 'string' ? JSON.parse(item.dados) : item.dados

      if (!dados) return ''

      if (
        this.escore.value === 'por-cadastro-esus' ||
        this.escore.value === 'por-parametro'
      ) {
        switch (column) {
          case 'CIs':
            return dados.qtd_cad0_75
          case 'CIs + CDTs':
            return dados.qtd_cad1_5
          case 'Cadastros':
            return dados.cad_pec ?? '-'
          case 'Parâmetro':
            return dados.cad_param ?? '-'
          case 'Máximo': {
            const param = Number(dados.cad_param)
            return isNaN(param) ? '-' : param * 1.5
          }
        }
      } else if (
        this.escore.value === 'acompanhamento-por-cadastro-esus' ||
        this.escore.value === 'acompanhamento-por-parametro-de-cadastro'
      ) {
        switch (column) {
          case 'A':
            return dados.qtd_acomp1_0
          case 'B':
            return dados.qtd_acomp1_2
          case 'C':
            return dados.qtd_acomp1_3
          case 'D':
            return dados.qtd_acomp2_5
          case 'Cadastros':
            return dados.cad_pec ?? '-'
          case 'Parâmetro':
            return dados.cad_param ?? '-'
          case 'Máximo': {
            const param = Number(dados.cad_param)
            return isNaN(param) ? '-' : param * 1.5
          }
        }
      } else if (
        this.escore.value === 'vinculo-acompanhamento-por-cadastro-esus'
      ) {
        switch (column) {
          case 'Cadastros':
            return dados.cad_pec ?? '-'
          case 'Parâmetro':
            return dados.cad_param ?? '-'
          case 'Escore cadastros':
            return dados.escore_pec_cad ?? '-'
          case 'Escore Acompanhamento':
            return dados.escore_pec_acomp ?? '-'
        }
      } else if (
        this.escore.value === 'vinculo-acompanhamento-por-parametro-de-cadastro'
      ) {
        switch (column) {
          case 'Cadastros':
            return dados.cad_pec ?? '-'
          case 'Parâmetro':
            return dados.cad_param ?? '-'
          case 'Escore cadastros':
            return this.getValorPrevistoRealizado(
              dados.escore_param_cad ?? '-',
              this.getResultadoIndicadorRealizadoPorId(item, 54)
            )

          case 'Escore Acompanhamento':
            return this.getValorPrevistoRealizado(
              dados.escore_param_acomp ?? '-',
              this.getResultadoIndicadorRealizadoPorId(item, 55)
            )
        }
      }

      return ''
    },

    /**
     * Retorna o resultado realizado de um indicador específico.
     *
     * Usado na tabela interna do indicador 56 para exibir
     * o previsto / realizado dos indicadores 54 e 55.
     *
     * @param {Object} item Registro da série histórica.
     * @param {Number|String} indicador Código do indicador realizado.
     * @returns {*}
     */
    getResultadoIndicadorRealizadoPorId(item, indicador) {
      const indicadorRealizado = this.getIndicadorRealizado(item, indicador)

      return indicadorRealizado?.resultado ?? '-'
    },

    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    /**
     * Atualiza o período selecionado e redefine os filtros
     * para a configuração padrão da tabela.
     *
     * @param {Object} periodo Período selecionado.
     * @returns {void}
     */
    onChangePeriodo(periodo) {
      this.filtroResultadoQuadrimestral = 'previsto'
      this.escore = {
        value: 'vinculo-acompanhamento-por-parametro-de-cadastro',
        label: 'Vínculo e acompanhamento por parâmetro de cadastro',
        indicador: '56',
      }
      this.selectedFilter = 'equipes'
      this.selectedCheckbox = ['equipes']
      this.filterData(periodo, this.escore, this.selectedCheckbox)
    },

    /**
     * Atualiza o indicador (escore) selecionado e redefine
     * os filtros para a configuração padrão da tabela.
     *
     * @param {Object} escore Indicador selecionado.
     * @returns {void}
     */
    onChangeEscore(escore) {
      this.escore = escore
      this.filtroResultadoQuadrimestral = 'previsto'
      this.selectedFilter = 'equipes'
      this.selectedCheckbox = ['equipes']
      this.filterData(this.periodo, escore, this.selectedCheckbox)
    },

    /**
     * Atualiza os dados da tabela conforme os níveis selecionados.
     *
     * @param {Array} item Lista de níveis selecionados.
     * @returns {void}
     */
    onChangeCheckbox(item) {
      this.filterData(this.periodo, this.escore, item)
    },

    /**
     * Filtra os registros conforme o nível selecionado
     * (Município, Equipes ou Microáreas).
     *
     * @param {Array} cadastros Lista de registros.
     * @param {Array} selectedCheckbox Níveis selecionados.
     * @returns {Array}
     */
    filterByCheckbox(cadastros, selectedCheckbox) {
      return cadastros.filter((el) => {
        const nivelMap = {
          municipio: 1,
          equipes: 2,
          microarea: 3,
        }
        return selectedCheckbox.some((checkboxValue) => {
          return el.nivel === nivelMap[checkboxValue]
        })
      })
    },

    /**
     * Filtra os registros pelo período selecionado.
     *
     * @param {Array} data Lista de registros.
     * @returns {Array}
     */
    filterByPeriodo(data) {
      return data.filter((el) => {
        return el.mes_ano === this.periodo.value
      })
    },

    /**
     * Filtra os registros pelo indicador (escore) selecionado.
     *
     * @param {Array} data Lista de registros.
     * @param {Object} escore Indicador selecionado.
     * @returns {Array}
     */
    filterByEscore(data, escore) {
      if (escore == null) {
        return []
      }
      return data.filter((el) => {
        return el.indicador == Number(escore.indicador)
      })
    },

    /**
     * Aplica todos os filtros da tabela.
     *
     * Os registros podem ser filtrados por período,
     * indicador e nível (Município, Equipes ou Microáreas).
     *
     * @param {Object|null} periodo Período selecionado.
     * @param {Object|null} escore Indicador selecionado.
     * @param {Array|null} checkbox Níveis selecionados.
     * @returns {void}
     */
    filterData(periodo, escore, checkbox) {
      let data = this.cadastros
      if (periodo != null) {
        data = this.filterByPeriodo(data)
      }
      if (escore != null) {
        data = this.filterByEscore(data, escore)
      }
      if (checkbox != null) {
        data = this.filterByCheckbox(data, checkbox)
      }
      this.dadosDaTabela = this.mapCadastros(data)
    },

    /**
     * Mapeia os registros da série histórica para o formato
     * utilizado pela tabela.
     *
     * Também aplica a lógica de exibição do resultado previsto
     * ou previsto / realizado quando o filtro estiver habilitado.
     *
     * @param {Array} cadastros Lista de registros.
     * @returns {Array}
     */
    mapCadastros(cadastros) {
      return cadastros
        .map((item, index) => {
          const dados =
            typeof item.dados === 'string' ? JSON.parse(item.dados) : item.dados

          if (!dados) {
            return {
              id: index,
              ...item,
              escore_previsto: '-',
              escore_realizado: '-',
              classificacao_prevista: '-',
              classificacao_realizada: '-',
              escore: '-',
              classificacao: '-',
            }
          }

          const isNivelNotTwo = item.nivel !== 2
          const isNivelTwo = item.nivel === 2

          let escore = ''
          let classificacao = ''

          if (isNivelNotTwo) {
            if (this.escore.label === 'Vínculo por cadastro no e-SUS') {
              escore = dados.escore_pec
              classificacao = dados.classificacao_pec
            }
            if (this.escore.label === 'Acompanhamento por cadastro e-SUS') {
              escore = dados.escore_pec
              classificacao = dados.classificacao_pec
            }
            if (
              this.escore.label ===
              'Vínculo e acompanhamento por cadastro e-SUS'
            ) {
              escore = dados.escore_vinc_acomp_pec
              classificacao = dados.classificacao_pec
            }
          }

          if (isNivelTwo) {
            if (this.escore.label === 'Vínculo por cadastro no e-SUS') {
              escore = dados.escore_pec
              classificacao = dados.classificacao_pec
            }
            if (this.escore.label === 'Vínculo por parâmetro de cadastro') {
              escore = dados.escore_param
              classificacao = dados.classificacao_param
            }
            if (this.escore.label === 'Acompanhamento por cadastro e-SUS') {
              escore = dados.escore_pec
              classificacao = dados.classificacao_pec
            }
            if (
              this.escore.label === 'Acompanhamento por parâmetro de cadastro'
            ) {
              escore = dados.escore_param
              classificacao = dados.classificacao_param
            }
            if (
              this.escore.label ===
              'Vínculo e acompanhamento por cadastro e-SUS'
            ) {
              escore = dados.escore_vinc_acomp_pec
              classificacao = dados.classificacao_pec
            }
            if (
              this.escore.label ===
              'Vínculo e acompanhamento por parâmetro de cadastro'
            ) {
              escore = dados.escore_vinc_acomp_param
              classificacao = dados.classificacao_param
            }
          }

          const escoreRealizado = this.getEscoreRealizado(item)
          const classificacaoRealizada = this.getClassificacaoRealizada(item)

          return {
            id: index,
            ...item,

            escore_previsto: escore,
            escore_realizado: escoreRealizado,
            classificacao_prevista: classificacao,
            classificacao_realizada: classificacaoRealizada,

            escore: this.getValorPrevistoRealizado(
              escore,
              this.getEscoreRealizado(item)
            ),
            classificacao: this.getValorPrevistoRealizado(
              classificacao,
              this.getClassificacaoRealizada(item)
            ),
          }
        })
        .sort((a, b) => a.escore - b.escore) // ordenação ASC
    },

    /**
     * Gera o relatório da tabela em PDF considerando
     * os filtros atualmente selecionados.
     *
     * @returns {void}
     */
    generatePdf() {
      let title_pdf = 'Resultado Municipal - Escore'
      let titlePdfSave = this.titlePdf('Resultado Municipal - Escore')
      let description_pdf =
        'Cidadãos e classificação por equipe no vínculo e acompanhamento.'
      let mainHeaders = this.isRealizadoSelecionado
        ? [
            'CNES',
            'UBS',
            'INE',
            'MICROÁREA',
            'ESCORE PREVISTO',
            'ESCORE REALIZADO',
            'CLASSIFICAÇÃO PREVISTA',
            'CLASSIFICAÇÃO REALIZADA',
          ]
        : ['CNES', 'UBS', 'INE', 'MICROÁREA', 'ESCORE', 'CLASSIFICAÇÃO']

      let extraHeaders = this.expandedColumns
      let headers_pdf = [...mainHeaders, ...extraHeaders]
      let data_pdf = this.mapCadastrosForPdf(this.dadosDaTabela)
      let doc = new jsPDF({ orientation: 'landscape', ...this.encryptionPdf() })

      let table = this.createTablePdf(data_pdf)
      this.fileToBase64(this.$store.state.infoMunicipio.brasao)
        .catch(() => '')
        .then((base64data) => {
          // Header
          let verticalPosition = this.headerPdf(
            doc,
            base64data,
            title_pdf,
            description_pdf
          )

          const filtro = this.selectedCheckbox
            .map((item) => {
              const corrections = {
                equipes: 'Equipes',
                microarea: 'Microáreas',
                municipio: 'Município',
              }
              return (
                corrections[item] ||
                item.charAt(0).toUpperCase() + item.slice(1)
              )
            })
            .join(', ')
          verticalPosition = this.bodyPdf(
            doc,
            [
              {
                label: 'Período',
                value: this.periodo?.label || this.periodo?.value || '',
              },
              {
                label: 'Indicador',
                value: this.escore?.label ?? '',
              },
              {
                label: 'Filtro',
                value: filtro,
              },
            ],
            verticalPosition
          )

          doc.autoTable({
            head: [headers_pdf],
            body: table,
            headStyles: {
              fillColor: '#ccc',
              fontSize: 6,
              textColor: '#000',
              halign: 'center',
              cellWidth: 'wrap',
            },
            bodyStyles: {
              halign: 'center',
              fontSize: 6,
            },
            theme: 'striped',
            startY: verticalPosition,
            showHead: 'firstPage',
            willDrawCell: function (data) {},
          })

          this.footerPdfCentralizado(doc, doc.autoTable.previous.finalY)

          doc.save(titlePdfSave + '.pdf')

          this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}

.icon-tooltip {
  margin-left: 5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-tooltip i {
  font-size: 14px;
  color: #000000;
  transition: color 0.3s ease-in-out;
}

.icon-tooltip i:hover {
  color: #0056b3;
}

.tabela .red-color {
  color: red !important;
}
</style>

<style scoped lang="scss">
.escore-filtros-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;

  @media screen and (max-width: 656px) {
    flex-direction: column;
  }
}

.escore-filtro-previsto-realizado {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  .resultado-toggle {
    margin-bottom: 0;
  }
  @media screen and (max-width: 656px) {
    flex-direction: column;
  }

  @media screen and (min-width: 657px) and (max-width: 807px) {
    flex-direction: column;
  }

  @media screen and (min-width: 808px) and (max-width: 1023px) {
    flex-direction: column;
  }
}
</style>
